export class ClmPerformanceInput {

  unitFamily!: string;
  unitSize!: string;
  voltage!: string;
  loadType!: string;
  blowerType!: string;
  chassisStyleType!: string;
  actualAirflow!: string;
  actualAirflowHeating!: string;
  enteringDryBulbTemperatureCooling!: string;
  enteringWetBulbTemperatureCooling!: string;
  enteringWaterTemperatureCooling!: string;
  performanceMethod!: string;
  totalCapacityCooling!: string;
  sensibleCapacityCooling!: string;
  leavingDryBulbTemperatureCooling!: string;
  fluidFlowCooling!: string;
  enteringDryBulbTemperatureHeating!: string;
  enteringWaterTemperatureHeating!: string;
  totalCapacityHeating!: string;
  altitude!: string;
  fluidType!: string;
  concentration!: string;
  desiredWaterflow!: string;
  desiredWaterflowTolerance!: string;
  totalCapacityCoolingLowerTolerance!: string;
  totalCapacityHeatingLowerTolerance!: string;
  sensibleCapacityLowerTolerance!: string;
  leavingAirDryBulbTemperatureLowerTolerance!: string;
  totalCapacityCoolingUpperTolerance!: string;
  totalCapacityHeatingUpperTolerance!: string;
  sensibleCapacityUpperTolerance!: string;
  leavingAirDryBulbTemperatureUpperTolerance!: string;
  fluidFlowTolerance!: string;
  minimumEer!: string;
  coolingActualAirflowLowerTolerance!: string;
  coolingActualAirflowUpperTolerance!: string;
  heatingActualAirflowLowerTolerance!: string;
  heatingActualAirflowUpperTolerance!: string;
  externalStaticPressure!: string;
  waterCircuitType!: string;
  extendedOptionType!: string;
  fanSpeedProfile!: string;
  loadEnteringWaterTemperatureCooling!: string;
  loadEnteringWaterTemperatureHeating!: string;
  fluidFlowLoad!: string;

}
